// extracted by mini-css-extract-plugin
export default {"section":"section-i_6E"};